export const DebriefIcon = ({ size = 18, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V3.30517C6.76667 3.3668 6.5414 3.44164 6.32122 3.53284C4.60602 4.2433 3.2433 5.60602 2.53284 7.32122C2.31883 7.8379 2.19414 8.38545 2.11952 9L21.8805 9C21.8059 8.38545 21.6812 7.8379 21.4672 7.32122C20.7567 5.60602 19.394 4.2433 17.6788 3.53284C17.4586 3.44164 17.2333 3.3668 17 3.30517V2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2V3.03923C14.1952 2.99996 13.2412 2.99998 12.084 3H11.916C10.7588 2.99998 9.8048 2.99996 9 3.03923V2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9908 11H2.00919C2 11.581 2 12.2346 2 12.9737V13.0368C2 14.4035 1.99999 15.4801 2.05941 16.351C2.11997 17.2387 2.2456 17.9853 2.53284 18.6788C3.2433 20.394 4.60602 21.7567 6.32122 22.4672C7.01469 22.7544 7.76134 22.88 8.649 22.9406C9.51986 23 10.5965 23 11.9631 23H12.0369C13.4035 23 14.4801 23 15.351 22.9406C16.2387 22.88 16.9853 22.7544 17.6788 22.4672C19.394 21.7567 20.7567 20.394 21.4672 18.6788C21.7544 17.9853 21.88 17.2387 21.9406 16.351C22 15.4801 22 14.4035 22 13.0369V12.9741C22 12.2348 22 11.5811 21.9908 11ZM6.9 14C6.9 13.3925 7.39249 12.9 8 12.9H8.01C8.61751 12.9 9.11 13.3925 9.11 14C9.11 14.6075 8.61751 15.1 8.01 15.1H8C7.39249 15.1 6.9 14.6075 6.9 14ZM10.9 14C10.9 13.3925 11.3925 12.9 12 12.9H12.01C12.6175 12.9 13.11 13.3925 13.11 14C13.11 14.6075 12.6175 15.1 12.01 15.1H12C11.3925 15.1 10.9 14.6075 10.9 14ZM14.9 14C14.9 13.3925 15.3925 12.9 16 12.9H16.01C16.6175 12.9 17.11 13.3925 17.11 14C17.11 14.6075 16.6175 15.1 16.01 15.1H16C15.3925 15.1 14.9 14.6075 14.9 14ZM6.9 18C6.9 17.3925 7.39249 16.9 8 16.9H8.01C8.61751 16.9 9.11 17.3925 9.11 18C9.11 18.6075 8.61751 19.1 8.01 19.1H8C7.39249 19.1 6.9 18.6075 6.9 18ZM10.9 18C10.9 17.3925 11.3925 16.9 12 16.9H12.01C12.6175 16.9 13.11 17.3925 13.11 18C13.11 18.6075 12.6175 19.1 12.01 19.1H12C11.3925 19.1 10.9 18.6075 10.9 18ZM14.9 18C14.9 17.3925 15.3925 16.9 16 16.9H16.01C16.6175 16.9 17.11 17.3925 17.11 18C17.11 18.6075 16.6175 19.1 16.01 19.1H16C15.3925 19.1 14.9 18.6075 14.9 18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DashboardIcon = ({ size = 14, ...props }) => {
  return (
    <svg
      width={size || width || 18}
      height={size || height || 18}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM2 16V2H8V16H2ZM16 16H10V9H16V16ZM16 7H10V2H16V7Z"
        fill="#737373"
      />
    </svg>
  );
};

export const DropdownIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 4.44444C9.5 4.56481 9.45671 4.66898 9.37012 4.75694L6.30762 7.86806C6.22103 7.95602 6.11849 8 6 8C5.88151 8 5.77897 7.95602 5.69238 7.86806L2.62988 4.75694C2.54329 4.66898 2.5 4.56481 2.5 4.44444C2.5 4.32407 2.54329 4.21991 2.62988 4.13194C2.71647 4.04398 2.81901 4 2.9375 4H9.0625C9.18099 4 9.28353 4.04398 9.37012 4.13194C9.45671 4.21991 9.5 4.32407 9.5 4.44444Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Dropdown2Icon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M7.75 9.75L12 14.25L16.25 9.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExportIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M3 15C3 17.7614 5.23858 20 8 20H16C18.7614 20 21 17.7614 21 15M9 12.1885C9.74024 13.1755 10.599 14.0668 11.5564 14.8426C11.6859 14.9475 11.843 15 12 15M15 12.1885C14.2598 13.1755 13.401 14.0668 12.4436 14.8426C12.3141 14.9475 12.157 15 12 15M12 15V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LogoutIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_80_4182)">
        <path
          d="M18.1885 9C19.1755 9.74024 20.0668 10.599 20.8426 11.5564C20.9475 11.6859 21 11.843 21 12M18.1885 15C19.1755 14.2598 20.0668 13.401 20.8426 12.4436C20.9475 12.3141 21 12.157 21 12M21 12H8M13 4.52779C11.9385 3.57771 10.5367 3 9 3C5.68629 3 3 5.68629 3 9V15C3 18.3137 5.68629 21 9 21C10.5367 21 11.9385 20.4223 13 19.4722"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_80_4182">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NextIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 23 23"
      fill="none"
      {...props}
    >
      <ellipse
        cx="11.5714"
        cy="11.3654"
        rx="11.3257"
        ry="11.1859"
        fill="white"
      />
      <ellipse
        cx="11.5714"
        cy="11.3654"
        rx="8.18592"
        ry="8.08486"
        fill="currentColor"
      />
      <path
        d="M10.3817 7.49518L14.2802 11.3455L10.3817 15.1959"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PreviousIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 23"
      fill="none"
      {...props}
    >
      <ellipse
        cx="11.7878"
        cy="11.7106"
        rx="11.2854"
        ry="11.1461"
        fill="white"
      />
      <ellipse
        cx="11.7879"
        cy="11.7106"
        rx="8.15677"
        ry="8.05607"
        fill="currentColor"
      />
      <path
        d="M12.9372 7.84038L9.0387 11.6907L12.9372 15.5411"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PauseIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 40 39"
      fill="none"
      {...props}
    >
      <ellipse
        cx="20.0049"
        cy="19.538"
        rx="19.6873"
        ry="19.4442"
        fill="white"
      />
      <ellipse
        cx="20.0048"
        cy="19.538"
        rx="14.2294"
        ry="14.0537"
        fill="currentColor"
      />
      <rect
        x="14.3521"
        y="13.3514"
        width="4.27778"
        height="12.3731"
        rx="2.13889"
        fill="white"
      />
      <rect
        x="21.3799"
        y="13.3514"
        width="4.27778"
        height="12.3731"
        rx="2.13889"
        fill="white"
      />
    </svg>
  );
};

export const PhoneIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M14.46 2C14.4 2.89 14.25 3.76 14.01 4.59L15.21 5.79C15.62 4.59 15.88 3.32 15.97 2H14.46ZM4.6 14.02C3.75 14.26 2.88 14.41 2 14.47V15.96C3.32 15.87 4.59 15.61 5.8 15.21L4.6 14.02ZM13.5 0H17C17.55 0 18 0.45 18 1C18 10.39 10.39 18 1 18C0.45 18 0 17.55 0 17V13.51C0 12.96 0.45 12.51 1 12.51C2.24 12.51 3.45 12.31 4.57 11.94C4.67 11.9 4.78 11.89 4.88 11.89C5.14 11.89 5.39 11.99 5.59 12.18L7.79 14.38C10.62 12.93 12.94 10.62 14.38 7.79L12.18 5.59C11.9 5.31 11.82 4.92 11.93 4.57C12.3 3.45 12.5 2.25 12.5 1C12.5 0.45 12.95 0 13.5 0Z"
        fill="#737373"
      />
    </svg>
  );
};

export const ProgressBarIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 291 37"
      fill="none"
      {...props}
    >
      <rect
        x="2.01501"
        y="5.1834"
        width="288.811"
        height="6.73809"
        rx="3.36905"
        fill="#FBFBFB"
      />
      <g filter="url(#filter0_di_92_2420)">
        <rect
          x="3.83423"
          y="6.98022"
          width="150.091"
          height="3.14444"
          rx="1.57222"
          fill="url(#paint0_linear_92_2420)"
        />
      </g>
      <g filter="url(#filter1_dii_92_2420)">
        <ellipse
          cx="153.925"
          cy="8.32784"
          rx="8.18678"
          ry="8.08571"
          fill="white"
        />
        <path
          d="M161.612 8.32784C161.612 12.5115 158.176 15.9135 153.925 15.9135C149.674 15.9135 146.239 12.5115 146.239 8.32784C146.239 4.1442 149.674 0.742126 153.925 0.742126C158.176 0.742126 161.612 4.1442 161.612 8.32784Z"
          stroke="white"
        />
      </g>
      <g filter="url(#filter2_di_92_2420)">
        <ellipse
          cx="153.926"
          cy="8.32785"
          rx="5.00303"
          ry="4.94127"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_92_2420"
          x="0.834229"
          y="5.98022"
          width="156.091"
          height="9.14444"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.170174 0 0 0 0 0.282593 0 0 0 0 0.704167 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_92_2420"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_92_2420"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="1"
            dy="1"
          />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_92_2420"
          />
        </filter>
        <filter
          id="filter1_dii_92_2420"
          x="135.739"
          y="-9.75787"
          width="36.3735"
          height="46.1714"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_92_2420"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_92_2420"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="-10"
            dy="-10"
          />
          <feGaussianBlur stdDeviation="10" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="softLight"
            in2="shape"
            result="effect2_innerShadow_92_2420"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="10"
            dy="10"
          />
          <feGaussianBlur stdDeviation="5" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_92_2420"
            result="effect3_innerShadow_92_2420"
          />
        </filter>
        <filter
          id="filter2_di_92_2420"
          x="143.922"
          y="1.38658"
          width="25.0061"
          height="21.8825"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.384908 0 0 0 0 0.292917 0 0 0 0 0.95 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_92_2420"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_92_2420"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="10"
            dy="10"
          />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_92_2420"
          />
        </filter>
        <linearGradient
          id="paint0_linear_92_2420"
          x1="7.31606"
          y1="8.4395"
          x2="7.60624"
          y2="14.7071"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA4C98" />
          <stop
            offset="1"
            stopColor="currentColor"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RepresentativeIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10.51 7.99C10.51 6.34 9.16 4.99 7.51 4.99C5.86 4.99 4.51 6.34 4.51 7.99C4.51 9.64 5.86 10.99 7.51 10.99C9.16 10.99 10.51 9.64 10.51 7.99ZM7.51 8.99C6.96 8.99 6.51 8.54 6.51 7.99C6.51 7.44 6.96 6.99 7.51 6.99C8.06 6.99 8.51 7.44 8.51 7.99C8.51 8.54 8.06 8.99 7.51 8.99ZM14.01 10.99C15.12 10.99 16.01 10.1 16.01 8.99C16.01 7.88 15.12 6.99 14.01 6.99C12.9 6.99 12 7.88 12.01 8.99C12.01 10.1 12.9 10.99 14.01 10.99ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM3.85 15.11C4.53 14.57 6.12 14 7.51 14C7.58 14 7.66 14.01 7.74 14.01C7.98 13.37 8.41 12.72 9.04 12.15C8.48 12.05 7.95 11.99 7.51 11.99C6.21 11.99 4.12 12.44 2.78 13.42C2.28 12.38 2 11.22 2 9.99C2 5.58 5.59 1.99 10 1.99C14.41 1.99 18 5.58 18 9.99C18 11.19 17.73 12.33 17.25 13.36C16.25 12.77 14.89 12.49 14.01 12.49C12.49 12.49 9.51 13.3 9.51 15.19V17.97C7.24 17.84 5.22 16.76 3.85 15.11Z"
        fill="#737373"
      />
    </svg>
  );
};

export const SearchIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <circle
        cx="5.5"
        cy="5"
        r="4.3"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <line
        x1="10.5101"
        y1="11"
        x2="8.5"
        y2="8.98995"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ShieldCheckIcon = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5436 1.42748C11.4215 1.11044 12.3827 1.11044 13.2607 1.42748L18.7259 3.40104C20.2058 3.93543 21.2349 5.28772 21.3556 6.85646L21.5826 9.80696C21.9458 14.5291 19.4977 19.0231 15.3333 21.2788L13.8446 22.0852C12.6289 22.7437 11.1593 22.7277 9.95824 22.0429L8.43757 21.1758C4.54948 18.9589 2.21824 14.7625 2.39025 10.2901L2.5175 6.98148C2.58012 5.3536 3.62372 3.92631 5.15597 3.373L10.5436 1.42748ZM15.7967 10.5597C16.2528 10.2482 16.3701 9.62599 16.0586 9.1699C15.7472 8.71381 15.125 8.59655 14.6689 8.908C13.2434 9.88139 11.9944 11.0936 10.9989 12.5078L9.83954 11.3497C9.44881 10.9594 8.81564 10.9597 8.42533 11.3505C8.03501 11.7412 8.03535 12.3744 8.42608 12.7647L10.4663 14.8027C10.6867 15.0228 10.9971 15.1277 11.3058 15.0863C11.6146 15.045 11.8864 14.8621 12.0411 14.5916C12.9623 12.9808 14.2532 11.6137 15.7967 10.5597Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowTopRightIcon = ({ size = 10, ...props }) => {
  return (
    <svg
      width={size || width || 10}
      height={size || height || 10}
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M3.33333 0V1.33333H7.72667L0 9.06L0.94 10L8.66667 2.27333V6.66667H10V0H3.33333Z"
        fill="white"
      />
    </svg>
  );
};

export const ChevronIcon = ({ size = 24, ...props }) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    role="presentation"
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M15.5 19l-7-7 7-7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const ChevronFullIcon = ({ size = 24, ...props }) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    role="presentation"
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 9 6"
    {...props}
  >
    <path
      d="M5.15513 4.89351C6.19135 4.05942 7.11563 3.08747 7.90387 2.00313C8.0009 1.87137 8.053 1.70555 8.03961 1.52959C8.00992 1.13951 7.66964 0.847361 7.27957 0.877046C5.42919 1.01786 3.57078 1.01786 1.7204 0.877046C1.33033 0.84736 0.990044 1.13951 0.960358 1.52959C0.946968 1.70554 0.999065 1.87137 1.0961 2.00312C1.88434 3.08747 2.80861 4.05942 3.84484 4.89352C4.22828 5.20217 4.77168 5.20217 5.15513 4.89351Z"
      fill="#171D1C"
    />
  </svg>
);

export const CopyIcon = ({ size = 16, ...props }) => (
  <svg
    fill="#11181c"
    viewBox="0 0 115.77 122.88"
    width={size || width || 16}
    height={size || height || 16}
    {...props}
  >
    <path d="M89.62,13.96v7.73h12.19h0.01v0.02c3.85,0.01,7.34,1.57,9.86,4.1c2.5,2.51,4.06,5.98,4.07,9.82h0.02v0.02 v73.27v0.01h-0.02c-0.01,3.84-1.57,7.33-4.1,9.86c-2.51,2.5-5.98,4.06-9.82,4.07v0.02h-0.02h-61.7H40.1v-0.02 c-3.84-0.01-7.34-1.57-9.86-4.1c-2.5-2.51-4.06-5.98-4.07-9.82h-0.02v-0.02V92.51H13.96h-0.01v-0.02c-3.84-0.01-7.34-1.57-9.86-4.1 c-2.5-2.51-4.06-5.98-4.07-9.82H0v-0.02V13.96v-0.01h0.02c0.01-3.85,1.58-7.34,4.1-9.86c2.51-2.5,5.98-4.06,9.82-4.07V0h0.02h61.7 h0.01v0.02c3.85,0.01,7.34,1.57,9.86,4.1c2.5,2.51,4.06,5.98,4.07,9.82h0.02V13.96L89.62,13.96z M79.04,21.69v-7.73v-0.02h0.02 c0-0.91-0.39-1.75-1.01-2.37c-0.61-0.61-1.46-1-2.37-1v0.02h-0.01h-61.7h-0.02v-0.02c-0.91,0-1.75,0.39-2.37,1.01 c-0.61,0.61-1,1.46-1,2.37h0.02v0.01v64.59v0.02h-0.02c0,0.91,0.39,1.75,1.01,2.37c0.61,0.61,1.46,1,2.37,1v-0.02h0.01h12.19V35.65 v-0.01h0.02c0.01-3.85,1.58-7.34,4.1-9.86c2.51-2.5,5.98-4.06,9.82-4.07v-0.02h0.02H79.04L79.04,21.69z M105.18,108.92V35.65v-0.02 h0.02c0-0.91-0.39-1.75-1.01-2.37c-0.61-0.61-1.46-1-2.37-1v0.02h-0.01h-61.7h-0.02v-0.02c-0.91,0-1.75,0.39-2.37,1.01 c-0.61,0.61-1,1.46-1,2.37h0.02v0.01v73.27v0.02h-0.02c0,0.91,0.39,1.75,1.01,2.37c0.61,0.61,1.46,1,2.37,1v-0.02h0.01h61.7h0.02 v0.02c0.91,0,1.75-0.39,2.37-1.01c0.61-0.61,1-1.46,1-2.37h-0.02V108.92L105.18,108.92z" />
  </svg>
);

export const CheckIcon = ({ size = 16, ...props }) => (
  <svg
    fill="none"
    viewBox="0 0 16 12"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    width={size || width || 16}
    height={size || height || 16}
    className="w-3.5 h-3.5 text-blue-700 dark:text-blue-500"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1 5.917 5.724 10.5 15 1.5"
    />
  </svg>
);

export const BarChartIcon = ({ size = 24, ...props }) => (
  <svg
    fill="none"
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      d="M6 14H4V7H6V14ZM10 14H8V4H10V14ZM14 14H12V10H14V14ZM16 16H2V2H16V16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z"
      fill="#737373"
    />
  </svg>
);

export const PhoneAltIcon = ({ size = 24, ...props }) => (
  <svg
    fill="none"
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_536_2767)">
      <path
        d="M21.2208 17.3159L17.9041 15.059C17.5664 14.8331 17.2269 14.719 16.8962 14.719C16.45 14.719 16.0256 14.9238 15.6367 15.3254L14.8308 16.1431C14.6195 16.3654 14.3249 16.4872 14.0026 16.4872C13.7979 16.4872 13.5936 16.4387 13.4128 16.3464C12.8105 16.0338 11.6659 15.1867 10.2595 13.7449C8.96128 12.4138 7.98256 11.2328 7.64487 10.5923C7.44923 10.1931 7.43026 9.57205 7.84718 9.15538L8.66256 8.36359C9.36615 7.67103 9.46487 6.86462 8.94026 6.09385L6.6818 2.7641C6.32051 2.25 5.90308 2 5.4059 2C4.83974 2 4.19897 2.32897 3.60077 2.92744L3.52 3.00846C2.51128 4.01667 2 5.27769 2 6.75462C2 9.61128 3.95692 13.2069 7.36949 16.6195C10.8526 20.089 14.3344 22 17.1754 22C18.6915 22 19.9718 21.4887 20.9803 20.48L20.9944 20.469L21.0087 20.4474C21.0228 20.4359 21.0364 20.4238 21.0503 20.4103C21.6805 19.78 22 19.1685 22 18.5941C22 18.0951 21.7377 17.6651 21.2208 17.3159Z"
        fill="white"
      />
      <path
        d="M11.6464 11.6464C11.4512 11.8417 11.4512 12.1583 11.6464 12.3536C11.8417 12.5488 12.1583 12.5488 12.3536 12.3536L11.6464 11.6464ZM18.5 6C18.5 5.72386 18.2761 5.5 18 5.5H13.5C13.2239 5.5 13 5.72386 13 6C13 6.27614 13.2239 6.5 13.5 6.5H17.5V10.5C17.5 10.7761 17.7239 11 18 11C18.2761 11 18.5 10.7761 18.5 10.5V6ZM12.3536 12.3536L18.3536 6.35355L17.6464 5.64645L11.6464 11.6464L12.3536 12.3536Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_536_2767">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BasketIcon = ({ size = 21, ...props }) => (
  <svg
    fill="none"
    width={size || width || 21}
    height={size || height || 21}
    viewBox="0 0 23 20"
    {...props}
  >
    <path
      d="M21.5 7.86867H16.71L12.33 1.30867C12.14 1.02867 11.82 0.888672 11.5 0.888672C11.18 0.888672 10.86 1.02867 10.67 1.31867L6.29 7.86867H1.5C0.95 7.86867 0.5 8.31867 0.5 8.86867C0.5 8.95867 0.51 9.04867 0.54 9.13867L3.08 18.4087C3.31 19.2487 4.08 19.8687 5 19.8687H18C18.92 19.8687 19.69 19.2487 19.93 18.4087L22.47 9.13867L22.5 8.86867C22.5 8.31867 22.05 7.86867 21.5 7.86867ZM11.5 3.66867L14.3 7.86867H8.7L11.5 3.66867ZM18 17.8687L5.01 17.8787L2.81 9.86867H20.2L18 17.8687ZM11.5 11.8687C10.4 11.8687 9.5 12.7687 9.5 13.8687C9.5 14.9687 10.4 15.8687 11.5 15.8687C12.6 15.8687 13.5 14.9687 13.5 13.8687C13.5 12.7687 12.6 11.8687 11.5 11.8687Z"
      fill="white"
    />
  </svg>
);

export const ReceiptIcon = ({ size = 21, ...props }) => (
  <svg
    fill="none"
    width={size || width || 21}
    height={size || height || 21}
    viewBox="0 0 19 21"
    {...props}
  >
    <path
      d="M17 1.87891L15.5 0.378906L14 1.87891L12.5 0.378906L11 1.87891L9.5 0.378906L8 1.87891L6.5 0.378906L5 1.87891L3.5 0.378906L2 1.87891L0.5 0.378906V20.3789L2 18.8789L3.5 20.3789L5 18.8789L6.5 20.3789L8 18.8789L9.5 20.3789L11 18.8789L12.5 20.3789L14 18.8789L15.5 20.3789L17 18.8789L18.5 20.3789V0.378906L17 1.87891ZM16.5 17.4689H2.5V3.28891H16.5V17.4689ZM3.5 13.3789H15.5V15.3789H3.5V13.3789ZM3.5 9.37891H15.5V11.3789H3.5V9.37891ZM3.5 5.37891H15.5V7.37891H3.5V5.37891Z"
      fill="white"
    />
  </svg>
);

export const SalesIcon = ({ size = 24, ...props }) => (
  <svg
    fill="none"
    width={size || width || 24}
    height={size || height || 20}
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      d="M19.91 9.79184L11.08 0.961836C10.71 0.591836 10.2 0.381836 9.67 0.381836H2.5C1.4 0.381836 0.5 1.28184 0.5 2.38184V9.55184C0.5 10.0818 0.71 10.5918 1.09 10.9618L9.92 19.7918C10.7 20.5718 11.97 20.5718 12.75 19.7918L19.92 12.6218C20.7 11.8418 20.7 10.5818 19.91 9.79184ZM11.33 18.3818L2.5 9.55184V2.38184H9.67L18.5 11.2118L11.33 18.3818Z"
      fill="white"
    />
    <path
      d="M5 6.38184C5.82843 6.38184 6.5 5.71026 6.5 4.88184C6.5 4.05341 5.82843 3.38184 5 3.38184C4.17157 3.38184 3.5 4.05341 3.5 4.88184C3.5 5.71026 4.17157 6.38184 5 6.38184Z"
      fill="white"
    />
  </svg>
);

export const ShareIcon = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 19 18"
    fill="none"
    {...props}
  >
    <path
      d="M11.0328 2.25H7.96719C6.94491 2.24999 6.13188 2.24999 5.47594 2.30358C4.80424 2.35846 4.23149 2.47326 3.70705 2.74047C2.97106 3.11548 2.35468 3.68464 1.92272 4.38317C1.82059 4.54832 1.87915 4.76138 2.04297 4.86563L6.6814 7.81736C7.89612 8.59036 8.35391 8.8695 8.82573 8.97833C9.26942 9.08067 9.73057 9.08067 10.1743 8.97833C10.6461 8.8695 11.1039 8.59036 12.3186 7.81736L16.957 4.86562C17.1209 4.76137 17.1794 4.54831 17.0773 4.38316C16.6453 3.68464 16.029 3.11548 15.293 2.74047C14.7685 2.47326 14.1958 2.35846 13.5241 2.30358C12.8681 2.24999 12.0551 2.24999 11.0328 2.25Z"
      fill="white"
    />
    <path
      d="M17.7108 6.67884C17.6964 6.45294 17.446 6.3324 17.2551 6.45393L13.0042 9.15904C11.9525 9.82874 11.2659 10.2659 10.5114 10.44C9.84586 10.5935 9.15413 10.5935 8.4886 10.44C7.73404 10.2659 7.04748 9.82873 5.99575 9.15903L1.74492 6.45393C1.55396 6.33241 1.30359 6.45294 1.28921 6.67883C1.24991 7.29664 1.24995 8.02643 1.25 8.90406L1.25001 9.03282C1.25 10.0551 1.25 10.8681 1.30359 11.5241C1.35847 12.1958 1.47326 12.7685 1.74048 13.293C2.17191 14.1397 2.86032 14.8281 3.70705 15.2595C4.23149 15.5267 4.80424 15.6415 5.47594 15.6964C6.13186 15.75 6.94486 15.75 7.9671 15.75H11.0328C12.0551 15.75 12.8682 15.75 13.5241 15.6964C14.1958 15.6415 14.7685 15.5267 15.293 15.2595C16.1397 14.8281 16.8281 14.1397 17.2595 13.293C17.5267 12.7685 17.6415 12.1958 17.6964 11.5241C17.75 10.8681 17.75 10.0551 17.75 9.0329L17.75 8.90405C17.7501 8.02644 17.7501 7.29665 17.7108 6.67884Z"
      fill="white"
    />
  </svg>
);

export const DownloadIcon = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 19 18"
    fill="none"
    {...props}
  >
    <path
      d="M2.75 11.25C2.75 13.3211 4.42893 15 6.5 15H12.5C14.5711 15 16.25 13.3211 16.25 11.25M7.25 9.14135C7.80518 9.88159 8.44925 10.5501 9.16732 11.132C9.26444 11.2107 9.38222 11.25 9.5 11.25M11.75 9.14135C11.1948 9.88159 10.5508 10.5501 9.83268 11.132C9.73556 11.2107 9.61778 11.25 9.5 11.25M9.5 11.25V3"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SparkleIcon = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M18.5025 6.5L19.4425 4.44L21.5025 3.5L19.4425 2.56L18.5025 0.5L17.5625 2.56L15.5025 3.5L17.5625 4.44L18.5025 6.5Z"
      fill="#737373"
    />
    <path
      d="M16.2125 8.62L13.3825 5.79C13.1825 5.6 12.9325 5.5 12.6725 5.5C12.4125 5.5 12.1625 5.6 11.9625 5.79L0.7925 16.96C0.4025 17.35 0.4025 17.98 0.7925 18.37L3.6225 21.2C3.8225 21.4 4.0725 21.5 4.3325 21.5C4.5925 21.5 4.8425 21.4 5.0425 21.21L16.2125 10.04C16.6025 9.65 16.6025 9.01 16.2125 8.62ZM12.6725 7.92L14.0825 9.33L12.9125 10.5L11.5025 9.09L12.6725 7.92ZM4.3325 19.09L2.9225 17.68L10.0925 10.5L11.5025 11.91L4.3325 19.09Z"
      fill="#737373"
    />
  </svg>
);

export const GlassyBookmarkIcon = ({ size = 52, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 57 61"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5552 13.1761L26.9762 8.90818C31.9851 7.0364 36.7777 7.49545 38.6941 12.5355L49.0836 40.6778C49.1984 40.9949 49.2348 41.3353 49.1898 41.6694C49.1198 42.213 48.8338 42.7041 48.3974 43.0299C47.9609 43.3556 47.4115 43.488 46.8754 43.3967L32.679 41.8658L22.8927 52.3654C22.1682 53.1977 20.9155 53.2909 20.0741 52.575C19.8209 52.3457 19.6258 52.0586 19.5051 51.7378L14.6533 38.5954C14.6037 38.4944 14.5585 38.3881 14.5172 38.2763L9.09737 23.5955C7.22993 18.5372 10.5626 15.0418 15.5552 13.1761Z"
      fill="url(#paint0_linear_2101_761)"
    />
    <g
      opacity="0.5"
      filter="url(#filter0_f_2101_761)"
    >
      <path
        d="M30.5978 15.6214L20.2223 18.4141C16.4588 19.427 14.858 22.2304 15.8698 26.0234L19.2964 38.8697C20.3247 42.7248 23.0931 44.2988 26.8566 43.2858L37.2321 40.4931C41.0563 39.4638 42.6084 36.7268 41.5801 32.8717L38.1535 20.0254C37.1417 16.2325 34.4219 14.592 30.5978 15.6214Z"
        fill="#2300FF"
      />
    </g>
    <g filter="url(#filter1_b_2101_761)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5237 51.9518L22.2929 59.233C21.2365 59.7845 19.9351 59.3941 19.3527 58.3511C19.1842 58.028 19.0933 57.6697 19.0873 57.305V25.0422C19.0873 18.8891 23.273 16.4279 29.2962 16.4279H43.4458C49.2854 16.4279 53.6548 18.725 53.6548 24.632V57.305C53.6548 57.8871 53.4246 58.4453 53.0149 58.8569C52.6052 59.2684 52.0495 59.4996 51.4701 59.4996C51.1005 59.4938 50.7372 59.4025 50.4083 59.233L37.0959 51.9518C36.6053 51.6856 36.0142 51.6856 35.5237 51.9518Z"
        fill="#4629FF"
      />
      <path
        d="M22.5243 59.6762L22.5243 59.6763L22.534 59.6711L35.7622 52.3913C35.7626 52.3911 35.763 52.3909 35.7633 52.3907C36.1049 52.2058 36.516 52.206 36.8574 52.3913L50.1684 59.6717L50.1683 59.6718L50.1793 59.6774C50.5765 59.8822 51.0155 59.9925 51.4621 59.9996V59.9996H51.4701C52.1828 59.9996 52.8659 59.7152 53.3693 59.2096C53.8725 58.7041 54.1548 58.019 54.1548 57.305V24.632C54.1548 21.5383 53.0009 19.3271 51.0324 17.9091C49.0908 16.5105 46.4186 15.9279 43.4458 15.9279H29.2962C26.2287 15.9279 23.5499 16.5527 21.6281 18.0313C19.6833 19.5277 18.5873 21.8411 18.5873 25.0422V57.305H18.5872L18.5873 57.3133C18.5947 57.7556 18.7049 58.1902 18.9094 58.5822L18.9162 58.5948C19.6299 59.8732 21.227 60.3535 22.5243 59.6762Z"
        stroke="url(#paint1_linear_2101_761)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter2_b_2101_761)">
      <path
        d="M43.0691 30.4371H29.4742C28.6908 30.4371 28.0558 29.7219 28.0558 28.8397C28.0558 27.9575 28.6908 27.2423 29.4742 27.2423H43.0691C43.8525 27.2423 44.4875 27.9575 44.4875 28.8397C44.4875 29.7219 43.8525 30.4371 43.0691 30.4371Z"
        fill="url(#paint2_linear_2101_761)"
      />
      <path
        d="M43.0691 30.2371H29.4742C28.823 30.2371 28.2558 29.6344 28.2558 28.8397C28.2558 28.0449 28.823 27.4423 29.4742 27.4423H43.0691C43.7204 27.4423 44.2875 28.0449 44.2875 28.8397C44.2875 29.6344 43.7204 30.2371 43.0691 30.2371Z"
        stroke="url(#paint3_linear_2101_761)"
        strokeWidth="0.4"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_2101_761"
        x="0.572571"
        y="0.319946"
        width="56.3173"
        height="58.2657"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="7.5"
          result="effect1_foregroundBlur_2101_761"
        />
      </filter>
      <filter
        id="filter1_b_2101_761"
        x="-5.91272"
        y="-8.57214"
        width="84.5675"
        height="93.0718"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feGaussianBlur
          in="BackgroundImageFix"
          stdDeviation="12"
        />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_2101_761"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2101_761"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_b_2101_761"
        x="13.0558"
        y="12.2423"
        width="46.4318"
        height="33.1947"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feGaussianBlur
          in="BackgroundImageFix"
          stdDeviation="7.5"
        />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_2101_761"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2101_761"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2101_761"
        x1="21.29"
        y1="11.0298"
        x2="35.111"
        y2="48.0724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BEB3FF" />
        <stop
          offset="1"
          stopColor="#2300FF"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2101_761"
        x1="24.5899"
        y1="21.4458"
        x2="52.6956"
        y2="49.3825"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="white"
          stopOpacity="0.25"
        />
        <stop
          offset="1"
          stopColor="white"
          stopOpacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2101_761"
        x1="43.3225"
        y1="27.8192"
        x2="25.5009"
        y2="30.8079"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop
          offset="1"
          stopColor="white"
          stopOpacity="0.2"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2101_761"
        x1="30.6715"
        y1="27.6145"
        x2="31.3102"
        y2="31.6837"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="white"
          stopOpacity="0.25"
        />
        <stop
          offset="1"
          stopColor="white"
          stopOpacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
);

export const settingsIcon = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4328 10.98C17.4728 10.66 17.5028 10.34 17.5028 10C17.5028 9.66 17.4728 9.34 17.4328 9.02L19.5428 7.37C19.7328 7.22 19.7828 6.95 19.6628 6.73L17.6628 3.27C17.5728 3.11 17.4028 3.02 17.2228 3.02C17.1628 3.02 17.1028 3.03 17.0528 3.05L14.5628 4.05C14.0428 3.65 13.4828 3.32 12.8728 3.07L12.4928 0.42C12.4628 0.18 12.2528 0 12.0028 0H8.00277C7.75277 0 7.54277 0.18 7.51277 0.42L7.13277 3.07C6.52277 3.32 5.96277 3.66 5.44277 4.05L2.95277 3.05C2.89277 3.03 2.83277 3.02 2.77277 3.02C2.60277 3.02 2.43277 3.11 2.34277 3.27L0.342769 6.73C0.212769 6.95 0.272769 7.22 0.462769 7.37L2.57277 9.02C2.53277 9.34 2.50277 9.67 2.50277 10C2.50277 10.33 2.53277 10.66 2.57277 10.98L0.462769 12.63C0.272769 12.78 0.222769 13.05 0.342769 13.27L2.34277 16.73C2.43277 16.89 2.60277 16.98 2.78277 16.98C2.84277 16.98 2.90277 16.97 2.95277 16.95L5.44277 15.95C5.96277 16.35 6.52277 16.68 7.13277 16.93L7.51277 19.58C7.54277 19.82 7.75277 20 8.00277 20H12.0028C12.2528 20 12.4628 19.82 12.4928 19.58L12.8728 16.93C13.4828 16.68 14.0428 16.34 14.5628 15.95L17.0528 16.95C17.1128 16.97 17.1728 16.98 17.2328 16.98C17.4028 16.98 17.5728 16.89 17.6628 16.73L19.6628 13.27C19.7828 13.05 19.7328 12.78 19.5428 12.63L17.4328 10.98ZM15.4528 9.27C15.4928 9.58 15.5028 9.79 15.5028 10C15.5028 10.21 15.4828 10.43 15.4528 10.73L15.3128 11.86L16.2028 12.56L17.2828 13.4L16.5828 14.61L15.3128 14.1L14.2728 13.68L13.3728 14.36C12.9428 14.68 12.5328 14.92 12.1228 15.09L11.0628 15.52L10.9028 16.65L10.7028 18H9.30277L8.95277 15.52L7.89277 15.09C7.46277 14.91 7.06277 14.68 6.66277 14.38L5.75277 13.68L4.69277 14.11L3.42277 14.62L2.72277 13.41L3.80277 12.57L4.69277 11.87L4.55277 10.74C4.52277 10.43 4.50277 10.2 4.50277 10C4.50277 9.8 4.52277 9.57 4.55277 9.27L4.69277 8.14L3.80277 7.44L2.72277 6.6L3.42277 5.39L4.69277 5.9L5.73277 6.32L6.63277 5.64C7.06277 5.32 7.47277 5.08 7.88277 4.91L8.94277 4.48L9.10277 3.35L9.30277 2H10.6928L11.0428 4.48L12.1028 4.91C12.5328 5.09 12.9328 5.32 13.3328 5.62L14.2428 6.32L15.3028 5.89L16.5728 5.38L17.2728 6.59L16.2028 7.44L15.3128 8.14L15.4528 9.27ZM10.0028 6C7.79277 6 6.00277 7.79 6.00277 10C6.00277 12.21 7.79277 14 10.0028 14C12.2128 14 14.0028 12.21 14.0028 10C14.0028 7.79 12.2128 6 10.0028 6ZM10.0028 12C8.90277 12 8.00277 11.1 8.00277 10C8.00277 8.9 8.90277 8 10.0028 8C11.1028 8 12.0028 8.9 12.0028 10C12.0028 11.1 11.1028 12 10.0028 12Z"
      fill="#737373"
    />
  </svg>
);

export const MedalIcon1 = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16537 7.13828V0.113281H0.832031V7.13828C0.832031 7.42995 0.982031 7.70495 1.24036 7.85495L4.7237 9.94662L3.8987 11.8966L1.05703 12.1383L3.21536 14.0049L2.55703 16.7799L4.9987 15.3049L7.44037 16.7799L6.79036 14.0049L8.9487 12.1383L6.10703 11.8966L5.28203 9.94662L8.76537 7.85495C9.01537 7.70495 9.16537 7.43828 9.16537 7.13828ZM4.16536 7.67161L2.4987 6.67161V1.77995H4.16536V7.67161ZM7.4987 6.67161L5.83203 7.67161V1.77995H7.4987V6.67161Z"
      fill="#4318FF"
    />
  </svg>
);

export const MedalIcon2 = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.06536 10.4389L6.9987 8.97227L8.9237 10.4389L8.19036 8.06393L10.1237 6.5306H7.75703L6.9987 4.18893L6.24036 6.5306H3.8737L5.7987 8.06393L5.06536 10.4389ZM13.6654 7.36393C13.6654 3.6806 10.682 0.697266 6.9987 0.697266C3.31536 0.697266 0.332031 3.6806 0.332031 7.36393C0.332031 9.0556 0.965365 10.5889 1.9987 11.7639V18.1973L6.9987 16.5306L11.9987 18.1973V11.7639C13.032 10.5889 13.6654 9.0556 13.6654 7.36393ZM6.9987 2.36393C9.75703 2.36393 11.9987 4.6056 11.9987 7.36393C11.9987 10.1223 9.75703 12.3639 6.9987 12.3639C4.24036 12.3639 1.9987 10.1223 1.9987 7.36393C1.9987 4.6056 4.24036 2.36393 6.9987 2.36393ZM6.9987 14.8639L3.66536 15.7139V13.1306C4.6487 13.6973 5.78203 14.0306 6.9987 14.0306C8.21536 14.0306 9.3487 13.6973 10.332 13.1306V15.7139L6.9987 14.8639Z"
      fill="#737373"
    />
  </svg>
);

export const SubjectSheetIcon = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M10.6667 1.33333V7.33333H7.33333V10.6667H1.33333V1.33333H10.6667ZM10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H8L12 8V1.33333C12 0.6 11.4 0 10.6667 0ZM6 7.33333H2.66667V6H6V7.33333ZM9.33333 4.66667H2.66667V3.33333H9.33333V4.66667Z"
      fill={props?.color || "#737373"}
    />
  </svg>
);

export const MagicWandIcon = ({ size = 24, ...props }) => (
  <svg
    width={size || width || 24}
    height={size || height || 24}
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M13.0017 5.41504L13.6283 4.04171L15.0017 3.41504L13.6283 2.78837L13.0017 1.41504L12.375 2.78837L11.0017 3.41504L12.375 4.04171L13.0017 5.41504Z"
      fill="#737373"
    />
    <path
      d="M11.475 6.82837L9.58833 4.94171C9.455 4.81504 9.28833 4.74837 9.115 4.74837C8.94167 4.74837 8.775 4.81504 8.64167 4.94171L1.195 12.3884C0.935 12.6484 0.935 13.0684 1.195 13.3284L3.08167 15.215C3.215 15.3484 3.38167 15.415 3.555 15.415C3.72833 15.415 3.895 15.3484 4.02833 15.2217L11.475 7.77504C11.735 7.51504 11.735 7.08837 11.475 6.82837ZM9.115 6.36171L10.055 7.30171L9.275 8.08171L8.335 7.14171L9.115 6.36171ZM3.555 13.8084L2.615 12.8684L7.395 8.08171L8.335 9.02171L3.555 13.8084Z"
      fill="#737373"
    />
  </svg>
);

export const UserGroupIcon = ({ size = 20, ...props }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4224 8.32533C10.4224 6.95033 9.2974 5.82533 7.9224 5.82533C6.5474 5.82533 5.4224 6.95033 5.4224 8.32533C5.4224 9.70033 6.5474 10.8253 7.9224 10.8253C9.2974 10.8253 10.4224 9.70033 10.4224 8.32533ZM7.9224 9.15866C7.46406 9.15866 7.08906 8.78366 7.08906 8.32533C7.08906 7.86699 7.46406 7.49199 7.9224 7.49199C8.38073 7.49199 8.75573 7.86699 8.75573 8.32533C8.75573 8.78366 8.38073 9.15866 7.9224 9.15866ZM13.3391 10.8253C14.2641 10.8253 15.0057 10.0837 15.0057 9.15866C15.0057 8.23366 14.2641 7.49199 13.3391 7.49199C12.4141 7.49199 11.6641 8.23366 11.6724 9.15866C11.6724 10.0837 12.4141 10.8253 13.3391 10.8253ZM9.9974 1.66699C5.3974 1.66699 1.66406 5.40033 1.66406 10.0003C1.66406 14.6003 5.3974 18.3337 9.9974 18.3337C14.5974 18.3337 18.3307 14.6003 18.3307 10.0003C18.3307 5.40033 14.5974 1.66699 9.9974 1.66699ZM4.8724 14.2587C5.43906 13.8087 6.76406 13.3337 7.9224 13.3337C7.98073 13.3337 8.0474 13.342 8.11406 13.342C8.31406 12.8087 8.6724 12.267 9.1974 11.792C8.73073 11.7087 8.28906 11.6587 7.9224 11.6587C6.83906 11.6587 5.0974 12.0337 3.98073 12.8503C3.56406 11.9837 3.33073 11.017 3.33073 9.99199C3.33073 6.31699 6.3224 3.32533 9.9974 3.32533C13.6724 3.32533 16.6641 6.31699 16.6641 9.99199C16.6641 10.992 16.4391 11.942 16.0391 12.8003C15.2057 12.3087 14.0724 12.0753 13.3391 12.0753C12.0724 12.0753 9.58906 12.7503 9.58906 14.3253V16.642C7.6974 16.5337 6.01406 15.6337 4.8724 14.2587Z"
      fill={props.color || "#737373"}
    />
  </svg>
);

export const AISuggestionIcon = ({ size = 14, ...props }) => {
  return (
    <svg
      width={size || 22}
      height={size || 20}
      viewBox="0 0 22 20"
      fill="white"
      {...props}
    >
      <path
        d="M13.06 8.69L11 7.75L13.06 6.81L14 4.75L14.94 6.81L17 7.75L14.94 8.69L14 10.75L13.06 8.69ZM3 12.75L3.94 10.69L6 9.75L3.94 8.81L3 6.75L2.06 8.81L0 9.75L2.06 10.69L3 12.75ZM7.5 7.75L8.59 5.34L11 4.25L8.59 3.16L7.5 0.75L6.41 3.16L4 4.25L6.41 5.34L7.5 7.75ZM3.5 19.25L9.5 13.24L13.5 17.24L22 7.68L20.59 6.27L13.5 14.24L9.5 10.24L2 17.75L3.5 19.25Z"
        fill="white"
      />
    </svg>
  );
};
